// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1uZNu","header":"ClearentDisclaimer_header__1jkD1","inner":"ClearentDisclaimer_inner__1p5T_"};